module.exports = __webpack_public_path__ + "static/media/just-in-case-support.4893c656.svg";